const PATIENT_ENROLLMENT_STATES = [
  { state: 0, title: 'Registering' },
  { state: 30, title: 'Active' }
];

type PATIENT_ENROLLMENT_STATES = typeof PATIENT_ENROLLMENT_STATES;

export default PATIENT_ENROLLMENT_STATES;
